import { render, staticRenderFns } from "./shamSchool.vue?vue&type=template&id=2964c230&scoped=true"
import script from "./shamSchool.vue?vue&type=script&lang=js"
export * from "./shamSchool.vue?vue&type=script&lang=js"
import style0 from "./shamSchool.vue?vue&type=style&index=0&id=2964c230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964c230",
  null
  
)

export default component.exports